export default __webpack_public_path__ + "static/media/Liver.0a2a442d.svg";